import { usePathname } from 'next/navigation'

import { SplitsLink as Link } from '~/components/Link'
import { Button } from '~/components/component-library'
import { cn } from '~/utils/tailwind-utils'

export const SidebarSection = ({
  title,
  items,
  size = 'small',
}: SidebarSectionProps) => {
  const pathname = usePathname()
  return (
    <div className="flex w-full flex-col gap-0.5">
      {title && (
        <label className="mb-1 px-2.5 pt-1 text-sm font-normal text-secondary">
          {title}
        </label>
      )}
      {items.map((page) => (
        <Link key={page.href} path={page.href}>
          <Button
            className={cn('overflow-hidden font-normal', {
              'pointer-events-none bg-gray-200 dark:bg-gray-800':
                page.href && pathname.startsWith(page.href),
            })}
            variant="tertiary"
            alignLeft
            fullWidth
            size={size}
            prefix={page.prefix}
          >
            {typeof page.title === 'string' ? (
              <span className="truncate">{page.title}</span>
            ) : (
              page.title
            )}
          </Button>
        </Link>
      ))}
    </div>
  )
}

type SidebarSectionProps = {
  title?: string
  items: SidebarItem[]
  size?: 'small' | 'base'
}

type SidebarItem = {
  prefix?: React.ReactElement
  title: React.ReactNode
  href: string
}
